<template>
  <div id="phonefind_wrap">
    <headers/>
    <div id="login_wrap_denglu">
      <div class="login_wrap_denglu_top">通过手机号找回密码</div>
      <router-link to="/reset-password-by-email" class="yanzhengma_enter">通过邮箱找回密码></router-link>
    </div>
    <div id="phonefind_form">
      <div class="phonefind_form_wrap">
        <div class="login_wrap_form_wrap_tip">手机号码</div>
        <div class="login_wrap_form_number">
          <div class="login_wrap_form_number_left">
            <el-select v-model="value" placeholder="" class="login_wrap_form_number_left_se" filterable>
              <el-option v-for="item in cities" :key="item.label" :label="item.value" :value="item.value">
                <span style="float: left">{{ item.label }}</span>
                <span style="float: right; color: #8492a6; font-size: 13px">{{ item.value }}</span>
              </el-option>
            </el-select>
          </div>
          <div class="login_wrap_form_number_right">
            <el-input v-model="input_content" placeholder="请输入手机号码" class="login_wrap_form_number_right_int" :class="{'colorerro':colorerro}"></el-input>
          </div>
        </div>
        <div class="number_erro" :class="{'colordisplays':errodisplay}">
          <div class="number_erro_content">{{numbererro}}</div>
        </div>
        <div class="yanzheng_code">验证码</div>
        <div class="yanzhengma_bor">
          <div class="yanzhengma_bor_left_infor">
            <el-input v-model="input_yanzhengma" placeholder="请输入验证码" :class="{'yanzhengdisplays':yanzhengdisplays}"></el-input>
          </div>
          <div class="yanzhengma_bor_btn" @click="getCode">
            <el-button class="impro_btn" :class="{'iscursor':iscursor}">获取验证码</el-button>
          </div>
        </div>
        <div class="yanzhengma_erro">
          <div :class="{'yanzheng_test':yanzheng_test}" class="yanzheng_cuowu">{{yanzhengma_con}}</div>
          <div class="yanzheng_time_lodaing" :class="{'yanzheng_loding':yanzheng_loding}">{{time_loging}}秒后可发送</div>
        </div>
        <div class="login_wrap_for_enter" @click="sub_enter">
          <div class="login_wrap_for_enter_con">下一步</div>
        </div>
      </div>
    </div>
    <footers/>
  </div>
</template>

<script>
import headers from "./header.vue";
import Net_Work from "../apis/network.js";
import footers from "./footers.vue";
import axios from "axios";
import Qs from "qs";
import Address from "../apis/address.js";

axios.defaults.baseURL = Net_Work.publicApi;
axios.defaults.headers.post["Content-Type"] = Net_Work.publicPostset;
export default {
  name: "phone-find",
  components: { headers, footers },
  data() {
    return {
      input_content: "",
      errodisplay: true,
      input_yanzhengma: "",
      numbererro: "手机号格式错误",
      yanzhengma_con: "验证码错误",
      time_loging: "60",
      yanzheng_loding: true,
      yanzhengdisplays: false,
      _conde_ma_key: "",
      colorerro: false,
      iscursor: false,
      yanzheng_test: true,
      value: "+86",
      cities: Address.citiy
    };
  },
  methods: {
    getCode() {
      var number_quhao = Number(this.value);
      let _this = this;
      var number_true = false;
      if (number_quhao === 86) {
        var repx1 = /^1[012345789]\d{9}$/g;
        if (this.input_content.length === 0) {
          this.errodisplay = false;
          this.colorerro = true;
          this.numbererro = "请输入手机号";
          return;
        }
        if (repx1.test(this.input_content)) {
          this.errodisplay = true;
          this.colorerro = false;
          number_true = true;
        } else {
          this.errodisplay = false;
          this.colorerro = true;
          this.numbererro = "手机号格式错误";
        }
      } else {
        var rexpx2 = /^[0-9]\d*$/g;
        if (this.input_content.length === 0) {
          this.errodisplay = false;
          this.colorerro = true;
          this.numbererro = "请输入手机号";
          return;
        }
        if (rexpx2.test(this.input_content)) {
          this.errodisplay = true;
          this.colorerro = false;
          number_true = true;
        } else {
          this.errodisplay = false;
          this.colorerro = true;
          this.numbererro = "手机号格式错误";
        }
      }
      if (number_true) {
        if (this.iscursor) {
          return;
        }
        this.iscursor = true;
        this.yanzheng_loding = false;
        let clock = setInterval(() => {
          this.time_loging--;
          if (this.time_loging < 0) {
            window.clearInterval(clock);
            this.time_loging = 60;
            this.iscursor = false;
            this.yanzheng_loding = true;
          }
        }, 1000);
        axios
          .post(
            "/n/api/sms/send",
            Qs.stringify({
              areaCode: number_quhao,
              phone: this.input_content
            })
          )
          .then(function(response) {
            if (response.data.code == 0) {
              _this._conde_ma_key = response.data.data.key;
              _this.yanzheng_test = true;
              _this.yanzhengdisplays = false;
            } else {
              _this.yanzheng_test = false;
              _this.yanzhengma_con = response.data.msg; /*错误提示文字 */
              _this.yanzhengdisplays = true;
            }
          })
          .catch(function(error) {
            console.log(error);
          });
      }
    },
    sub_enter() {
      var number_quhao = Number(this.value);
      let _this = this;
      var _erweima = false;
      var number_true = false;
      if (number_quhao === 86) {
        var repx1 = /^1[012345789]\d{9}$/g;
        if (this.input_content.length === 0) {
          this.errodisplay = false;
          this.colorerro = true;
          this.numbererro = "请输入手机号";
          return;
        }
        if (repx1.test(this.input_content)) {
          this.errodisplay = true;
          this.colorerro = false;
          number_true = true;
        } else {
          this.errodisplay = false;
          this.colorerro = true;
          this.numbererro = "手机号格式错误";
        }
      } else {
        var rexpx2 = /^[0-9]\d*$/g;
        if (this.input_content.length === 0) {
          this.errodisplay = false;
          this.colorerro = true;
          this.numbererro = "请输入手机号";
          return;
        }
        if (rexpx2.test(this.input_content)) {
          this.errodisplay = true;
          this.colorerro = false;
          number_true = true;
        } else {
          this.errodisplay = false;
          this.colorerro = true;
          this.numbererro = "手机号格式错误";
        }
      }
      if (number_true) {
        var rexp_3 = /^[0-9]{6}$/g;
        if (this.input_yanzhengma == "") {
          this.yanzheng_test = false;
          this.yanzhengma_con = "验证码必须是6位数字";
          this.yanzhengdisplays = true;
        } else if (rexp_3.test(this.input_yanzhengma)) {
          this.yanzheng_test = true;
          this.yanzhengdisplays = false;
          _erweima = true;
        } else {
          this.yanzheng_test = false;
          this.yanzhengma_con = "验证码必须是6位数字";
          this.yanzhengdisplays = true;
        }
      }
      if (number_true && _erweima) {
        if (!this._conde_ma_key) {
          this.yanzheng_test = false;
          this.yanzhengma_con = "验证码错误";
          this.yanzhengdisplays = true;
        } else {
          this.yanzheng_test = true;
          this.yanzhengdisplays = false;
          axios
            .post(
              "/s/api/user/phone/find/password" /*最新代码位置*/,
              Qs.stringify({
                areaCode: number_quhao,
                key: this._conde_ma_key,
                phone: _this.input_content,
                smsVerification: _this.input_yanzhengma
              })
            )
            .then(function(response) {
              if (response.data.code === 0) {
                window.sessionStorage.setItem(
                  "my-dbclass-change-password-key",
                  response.data.key
                );
                _this.$message({
                  message: response.data.msg,
                  type: "success",
                  duration: 1000,
                  onClose() {
                    _this.$router.push("/reset-password");
                  }
                });
              } else {
                _this.$message({
                  showClose: true,
                  message: response.data.msg,
                  type: "error"
                });
              }
            })
            .catch(function(error) {});
        }
      }
    }
  }
};
</script>
<style lang="less" scoped>
#phonefind_wrap {
  #login_wrap_denglu {
    width: 100%;
    height: 155px;
    overflow: hidden;
    background-color: #eee;
    text-align: center;
    .login_wrap_denglu_top {
      font-family: " MicrosoftYaHei";
      font-size: 30px;
      color: #222743;
      margin-top: 45px;
    line-height: 52px;
    letter-spacing: 1px;
    }
    .yanzhengma_enter {
      color: #066fff;
      font-family: " MicrosoftYaHei";
      margin-top: 10px;
      display: inline-block;
    }
  }
  #phonefind_form {
    width: 100%;
    padding-bottom: 80px;
    .phonefind_form_wrap {
      width: 360px;
      height: auto;
      margin: 0 auto;
      margin-top: 36px;
      .login_wrap_form_wrap_tip {
        font-family: "MicrosoftYaHei";
        font-size: 12px;
        color: #999999;
        margin-left: 50px;
      }
    }
    .colordisplays {
      visibility: hidden;
    }
    .yanzheng_test {
      visibility: hidden;
    }
    .yanzheng_loding {
      visibility: hidden;
    }
    .iscursor {
      cursor: no-drop;
    }
    .login_wrap_form_number {
      display: flex;
      -webkit-box-pack: justify;
      -ms-flex-pack: justify;
      justify-content: space-between;
      margin-top: 10px;
      .login_wrap_form_number_left {
        margin-left: 50px;
        .login_wrap_form_number_left_se {
          width: 80px;
          height: 30px;
        }
      }
      .login_wrap_form_number_right {
        margin-right: 50px;
        width: 170px;
      }
    }
    .number_erro {
      display: flex;
      margin-top: 3px;
      -webkit-box-pack: end;
      -ms-flex-pack: end;
      justify-content: flex-end;
      .number_erro_content {
        margin-right: 50px;
        width: 170px;
        font-size: 12px;
        color: #f56c6c;
        font-family: "MicrosoftYaHei";
      }
    }
    .yanzheng_code {
      font-family: "MicrosoftYaHei";
      font-size: 12px;
      color: #999999;
      margin-top: 3px;
      margin-left: 50px;
    }
    .yanzhengma_bor {
      display: flex;
      -webkit-box-pack: justify;
      -ms-flex-pack: justify;
      justify-content: space-between;
      margin-top: 10px;
      .yanzhengma_bor_left_infor {
        margin-left: 50px;
        width: 170px;
        height: 30px;
      }
      .yanzhengma_bor_btn {
        margin-right: 50px;
        .impro_btn {
          width: 87px;
          line-height: 30px;
          display: block;
          padding: 0px;
          text-align: center;
          font-size: 12px;
          color: #3366ff;
          border-color: #cccccc;
        }
      }
    }
    .yanzhengma_erro {
      display: flex;
      -webkit-box-pack: justify;
      -ms-flex-pack: justify;
      justify-content: space-between;
      margin-top: 3px;
      .yanzheng_cuowu {
        font-size: 12px;
        color: #f56c6c;
        font-family: "MicrosoftYaHei";
        margin-left: 50px;
      }
      .yanzheng_time_lodaing {
        font-size: 12px;
        color: #909399;
        font-family: "MicrosoftYaHei";
        margin-right: 50px;
      }
    }
    .login_wrap_for_enter {
      margin-left: 50px;
      margin-top: 12px;
      .login_wrap_for_enter_con {
        width: 260px;
        line-height: 30px;
        text-align: center;
        background-color: #3366ff;
        font-family: "MicrosoftYaHei";
        font-size: 14px;
        color: #ffffff;
        cursor: pointer;
      }
    }
  }
}
</style>
<style lang="less">
#phonefind_form {
  .el-input--suffix .el-input__inner {
    height: 30px;
    padding: 0;
    padding-left: 11px;
    display: block;
    margin-right: 11px;
  }
  .el-input__icon {
    line-height: 30px;
  }
  .yanzhengdisplays .el-input__inner {
    border-color: #f56c6c;
  }
  .colorerro .el-input__inner {
    border-color: #f56c6c;
  }
  .el-input__inner {
    padding: 0;
    margin: 0;
    width: 100%;
    padding-left: 11px;
    border-radius: 3px;
    height: 30px;
  }
  .yanzhengma_bor_btn {
    .el-button:focus,
    .el-button:hover {
      color: #3366ff;
      border-color: #ccc;
      background-color: none;
      background-color: #ffffff;
    }
  }
  .country_select {
    .el-input__inner {
      height: 24px;
    }
    .el-input__icon {
      line-height: 24px;
    }
  }
}
</style>





// WEBPACK FOOTER //
// src/components/phonefind.vue